import React from 'react';
import Datetime, { DatetimepickerProps } from 'react-datetime';
import { Global } from '@emotion/core';
import { DatetimeGlobalStyles } from './styles';
import { getCurrentDateAtUpcomingHour } from './util';

/**
 * This component just glues the redux-forms and Datetime components together
 */
export const FieldDatetimeWithRedux = ({
  input: { onChange, value },
}: {
  input: Pick<DatetimepickerProps, 'onChange' | 'value'>;
}) => {
  const dateTimeValue =
    !value || value === '' ? getCurrentDateAtUpcomingHour() : value;
  return (
    <>
      <Global styles={DatetimeGlobalStyles} />
      <Datetime
        className="DatetimeContainer"
        input={false}
        timeConstraints={{
          minutes: { min: 0, max: 0, step: 60 },
          seconds: { min: 0, max: 0, step: 60 },
          milliseconds: { min: 0, max: 0, step: 1000 },
        }}
        onChange={onChange}
        value={dateTimeValue}
      />
    </>
  );
};
